export const SOURCE_STRINGS = {
  Nespechej: 'Nespěchej.cz',
  NasDum: 'Nášdům.eu',
  PlneZdravi: 'Plnézdraví.cz',
  NaseZahrada: 'Našezahrada.com',
  EPenize: 'Epeníze.eu',
  SvetCestovatele: 'Světcestovatele.cz',
  Aktualne: 'Aktuálně.cz',
  Vareni: 'Vaření.cz',
  Woman: 'Žena.cz',
  Respekt: 'Respekt',
  Nova: 'TN.cz',
  Utulne: 'Útulně',
  Video: 'Aktuálně.cz',
  Magazin: 'Aktuálně.cz',
  MagazinZahrada: 'Magazín zahrada',
  AktualneAuto: 'Aktuálně.cz',
  VitalWeb: 'Vitalweb.cz',
  CzechSight: 'CzechSight',
  Kinotip: 'Kinotip',
  Zdrave: 'Zdravě',
  FajntipLifestyle: 'Fajntip',
  FajntipPsychologie: 'Fajntip',
  Ekonom: 'Ekonom',
  Mimibazar: 'Mimibazar'
}

export const SOURCE_IMAGES = {
  Nespechej: 'nespechej.png',
  NasDum: 'nasdum.png',
  PlneZdravi: 'plnezdravi.png',
  NaseZahrada: 'nasezahrada.png',
  EPenize: 'epenize.png',
  SvetCestovatele: 'svetcestovatele.png',
  Aktualne: 'aktualne.svg',
  Vareni: 'vareni.svg',
  Woman: 'zena.svg',
  Respekt: 'respekt.svg',
  Nova: 'tn.svg',
  Utulne: 'utulne.svg',
  Video: 'aktualne.svg',
  Magazin: 'aktualne.svg',
  MagazinZahrada: 'magazinzahrada.png',
  AktualneAuto: 'aktualne.svg',
  VitalWeb: 'vitalweb.svg',
  CzechSight: 'czechsight.png',
  Kinotip: 'kinotip.png',
  Zdrave: 'zdrave.svg',
  FajntipLifestyle: 'fajntip.png',
  FajntipPsychologie: 'fajntip.png',
  Ekonom: 'ekonom.svg',
  Mimibazar: 'mimibazar.png'
}

export const ALREADY_USED_ARTICLES_WIDGETS = [
  'dynamiclead',
  'news',
  'video',
  'woman',
  'sport',
  'magazine',
  'finance',
  'newsfeed',
  'celebritiesInverted'
]
